import AWS from './aws';
import GCP from './gcp';
import Auth from './auth';
import Dashboard from './dashboardActions';
import Events from './events';
import Plugins from './plugins';
import Highlevel from './highlevel';

export default {
  AWS,
  GCP,
  Auth,
  Dashboard,
  Events,
  Plugins,
  Highlevel
};



// WEBPACK FOOTER //
// ./src/actions/index.js